var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_2170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.337 22.5H62.1266C63.7128 22.5 64.9986 23.7759 64.9986 25.3499V40.5255C64.9986 46.3104 60.2727 50.9999 54.4429 50.9999H54.393C48.5633 51.0008 43.8368 46.3118 43.8359 40.5269C43.8359 40.5264 43.8359 40.5261 43.8359 40.5255V23.9895C43.8359 23.1668 44.5079 22.5 45.337 22.5Z",
    fill: "#3A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.337 22.5H62.1266C63.7128 22.5 64.9986 23.7759 64.9986 25.3499V40.5255C64.9986 46.3104 60.2727 50.9999 54.4429 50.9999H54.393C48.5633 51.0008 43.8368 46.3118 43.8359 40.5269C43.8359 40.5264 43.8359 40.5261 43.8359 40.5255V23.9895C43.8359 23.1668 44.5079 22.5 45.337 22.5Z",
    fill: "url(#paint0_linear_1161_2170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6851 19.5C60.442 19.5 63.4875 16.4779 63.4875 12.75C63.4875 9.02208 60.442 6 56.6851 6C52.9283 6 49.8828 9.02208 49.8828 12.75C49.8828 16.4779 52.9283 19.5 56.6851 19.5Z",
    fill: "#3A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6851 19.5C60.442 19.5 63.4875 16.4779 63.4875 12.75C63.4875 9.02208 60.442 6 56.6851 6C52.9283 6 49.8828 9.02208 49.8828 12.75C49.8828 16.4779 52.9283 19.5 56.6851 19.5Z",
    fill: "url(#paint1_linear_1161_2170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.521 19.5002C40.9476 19.5002 45.3467 15.135 45.3467 9.75011C45.3467 4.36527 40.9476 0 35.521 0C30.0944 0 25.6953 4.36527 25.6953 9.75011C25.6953 15.135 30.0944 19.5002 35.521 19.5002Z",
    fill: "#3A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.521 19.5002C40.9476 19.5002 45.3467 15.135 45.3467 9.75011C45.3467 4.36527 40.9476 0 35.521 0C30.0944 0 25.6953 4.36527 25.6953 9.75011C25.6953 15.135 30.0944 19.5002 35.521 19.5002Z",
    fill: "url(#paint2_linear_1161_2170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6264 22.5H20.9122C19.345 22.5385 18.105 23.8292 18.1414 25.3847V42.6931C17.9224 52.0264 25.364 59.7717 34.7695 60C44.1749 59.7717 51.6162 52.0264 51.3975 42.6931V25.3847C51.4337 23.8292 50.1939 22.5385 48.6264 22.5Z",
    fill: "#3A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6264 22.5H20.9122C19.345 22.5385 18.105 23.8292 18.1414 25.3847V42.6931C17.9224 52.0264 25.364 59.7717 34.7695 60C44.1749 59.7717 51.6162 52.0264 51.3975 42.6931V25.3847C51.4337 23.8292 50.1939 22.5385 48.6264 22.5Z",
    fill: "url(#paint3_linear_1161_2170)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.281 22.5V46.7552C36.2734 47.8676 35.5942 48.8666 34.5577 49.2903C34.2276 49.4289 33.873 49.5001 33.5145 49.5004H19.4715C19.275 49.0055 19.0936 48.5104 18.9425 48.0005C18.4135 46.2792 18.1435 44.4899 18.1414 42.6904V25.38C18.105 23.8272 19.3429 22.5385 20.9075 22.5H36.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.7694 22.5V48.2551C34.7694 48.6108 34.6974 48.9627 34.5577 49.2903C34.1311 50.3188 33.124 50.9927 32.003 51.0003H20.182C19.925 50.5054 19.6833 50.0103 19.4715 49.5004C19.2598 48.9905 19.0936 48.5104 18.9425 48.0005C18.4135 46.2792 18.1435 44.4899 18.1414 42.6904V25.38C18.105 23.8272 19.3429 22.5385 20.9075 22.5H34.7694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.7694 22.5V45.255C34.7578 46.7662 33.5262 47.9886 32.0033 47.9999H18.9425C18.4135 46.2786 18.1435 44.4893 18.1414 42.6899V25.38C18.105 23.8272 19.3429 22.5385 20.9075 22.5H34.7694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.2576 22.5V45.255C33.2459 46.7662 32.0144 47.9886 30.4915 47.9999H18.9425C18.4135 46.2786 18.1435 44.4893 18.1414 42.6899V25.38C18.105 23.8272 19.3429 22.5385 20.9075 22.5H33.2576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.2783 14.7451V19.4702C36.0213 19.4853 35.7796 19.5003 35.5223 19.5003C35.2651 19.5003 35.0237 19.4853 34.7664 19.4702C34.2561 19.4366 33.7501 19.3562 33.2549 19.2303C30.1939 18.5109 27.6649 16.3807 26.4526 13.5004C26.2441 13.0168 26.0819 12.5144 25.9688 12.0005H33.5118C35.0374 12.006 36.2724 13.2316 36.2783 14.7451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.767 16.2448V19.4701C34.2566 19.4365 33.7507 19.356 33.2555 19.2302C30.1945 18.5107 27.6654 16.3805 26.4531 13.5002H32.0009C33.5261 13.5057 34.7612 14.7313 34.767 16.2448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.767 16.2448V19.4701C34.2566 19.4365 33.7507 19.356 33.2555 19.2302C30.1945 18.5107 27.6654 16.3805 26.4531 13.5002H32.0009C33.5261 13.5057 34.7612 14.7313 34.767 16.2448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.2555 16.2449V19.2299C30.1945 18.5105 27.6654 16.3803 26.4531 13.5H30.4893C32.0146 13.5058 33.2496 14.7314 33.2555 16.2449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7708 13.5H30.485C32.0152 13.5 33.2558 14.7311 33.2558 16.2495V43.7505C33.2558 45.2689 32.0152 46.5 30.485 46.5H2.7708C1.24061 46.5 0 45.2689 0 43.7505V16.2495C0 14.7311 1.24061 13.5 2.7708 13.5Z",
    fill: "#3A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7708 13.5H30.485C32.0152 13.5 33.2558 14.7311 33.2558 16.2495V43.7505C33.2558 45.2689 32.0152 46.5 30.485 46.5H2.7708C1.24061 46.5 0 45.2689 0 43.7505V16.2495C0 14.7311 1.24061 13.5 2.7708 13.5Z",
    fill: "url(#paint4_linear_1161_2170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9202 23.967H18.3801V38.9371H14.8504V23.967H9.33594V21.0629H23.9202V23.967Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1161_2170",
    x1: 43.8359,
    y1: 36.75,
    x2: 64.9986,
    y2: 36.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1161_2170",
    x1: 49.8828,
    y1: 12.75,
    x2: 63.4875,
    y2: 12.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1161_2170",
    x1: 25.6953,
    y1: 9.75011,
    x2: 45.3467,
    y2: 9.75011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1161_2170",
    x1: 18.1367,
    y1: 41.25,
    x2: 51.4022,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1161_2170",
    x1: 0,
    y1: 30,
    x2: 33.2558,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_2170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/microsoftTeams.b090991f22711a050f8d6daff76b9abc.svg";
export { ForwardRef as ReactComponent };